import { render } from "./ChangeAmountSlots.vue?vue&type=template&id=ce086e54&scoped=true"
import script from "./ChangeAmountSlots.vue?vue&type=script&lang=js"
export * from "./ChangeAmountSlots.vue?vue&type=script&lang=js"

import "./ChangeAmountSlots.vue?vue&type=style&index=0&id=ce086e54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce086e54"]])

export default __exports__